<template>
  <div id="my-support">
    <div class="row reverse-mobile" id="my-contracts">
      <div class="col-12 col-md-3">
        <UserMenu></UserMenu>
      </div>
      <div class="col-12 col-md-9">
        <div class="row mb-4">
          <div class="d-flex flex-row align-items-center">
            <i class="material-icons material-icons-title mr-2">save_alt</i>
            <h2 class="mt-2">Available Downloads</h2>
          </div>
        </div>
        <div class="alert alert-secondary mb-4" role="alert">
          <strong>IMPORTANT INFORMATION</strong>

          <p>You will need to perform the following additional steps after installing before running the application:</p>

          <ul>
            <li>Go to iPad Settings</li>
            <li>Select General</li>
            <li>Select Profile</li>
            <li>GS Elektromedizinische Geräte G. Stemple GmbH</li>
            <li>
              Click
              <em>"Trust GS Elektromedizinische Geräte G. Stemple GmbH"</em>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
export default {
  name: "MyDownloads",
  components: {
    UserMenu
  }
};
</script>

<style scoped>
.download img {
  max-width: 100%;
  height: auto;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
